<template>
    <i :class="primeVueIconClasses" v-bind="otherAttrs" />
</template>

<script>
import { getColorClass, getIconSizeClass } from './utils/componentMappings.js';
/**
 * EIcon - Abstraction wrapper for icons
 *
 * Usage (PrimeVue):
 *   <e-icon icon="trash" />
 *   <e-icon icon="plus" type="danger" />
 *   <e-icon icon="lock" size="large" />
 *
 * Props:
 *   - forcePrimeVue: Boolean - Force using PrimeVue icon rendering
 *   - icon: String - Icon name (without prefix, e.g., "trash", "plus")
 *   - size: String - Icon size (accepts both 'is-small'/'is-medium'/'is-large' and 'small'/'medium'/'large')
 *   - type: String - Icon color type (accepts both 'is-danger'/'is-success' and 'danger'/'success')
 *
 * All Buefy b-icon props and events are supported when forcePrimeVue is false.
 */
export default {
    name: 'EIcon',
    inheritAttrs: false,
    computed: {
        primeVueIconClasses() {
            const classes = [];
            const { icon } = this.$attrs;
            const { size } = this.$attrs;
            const { type } = this.$attrs;

            // Add base icon class (using Unicons to match current setup)
            if (icon && typeof icon === 'string' && !icon.includes('pi')) {
                classes.push('uil', `uil-${icon}`);
            } else if (typeof icon === 'string') {
                classes.push(icon);
            }

            // Add size class using shared mapping
            classes.push(getIconSizeClass(size));

            // Add type/color class using shared mapping
            if (type) {
                const colorClass = getColorClass(type);
                if (colorClass) {
                    classes.push(colorClass);
                }
            }

            return classes;
        },
        otherAttrs() {
            // Filter out icon-specific attrs for PrimeVue mode
            const { icon, size, type, ...rest } = this.$attrs;
            return rest;
        },
    },
};
</script>
